/*
 * Public API Surface of ngx-filemanager-api-firebase
 */

export * from './lib/endpoint/endpoint-express';
